import { useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import Cookies from 'js-cookie';
import axios from 'axios';

import NegativeBalancePopup from '../Components/Modal/NegativeBalancePopup';
import BgFormAnimate from './BgFormAnimate';

import login from '../images/persone-logo.png'

import '../css/loginPage.css'

function Login() {
    
    const inputRefs = useRef([]);

    const [email, setEmail] = useState('')
    const [pass, setPass] = useState('')
    const [validateEmail, setValidateEmail] = useState(false)
    const [validatePass, setValidatePass] = useState(false)
    const [userId, setUserId] = useState("")
    const [error, setError] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [status, setStatus] = useState('')
    const [codeInputs, setCodeInputs] = useState(['', '', '', '', '']);
    const [inputError, setInputError] = useState(false);
    const [invalidOtpError, setInvalidOtpError] = useState(false);
    const [loginData, setLoginData] = useState()
    const [authEmail, setAuthEmail] = useState('')
    const [isBack, setBack] = useState(false)
    const [openBalancePopup, setOpenBalancePopup] = useState(false)
    const [paymentData, setPaymentData] = useState('')
    const [rememberMe, setRememberMe] = useState(false);

    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    let response = "";
    let userResponse = "";

    const handleSubmit = (e) => {
        e.preventDefault();

        if (email.length > 0) {
            setValidateEmail(false);
        } else {
            setValidateEmail(true)
        }

        if (pass.length > 0) {
            setValidatePass(false);
        } else {
            setValidatePass(true);
        }

        if (emailPattern.test(email)) {
            setValidateEmail(false);
        } else {
            setValidateEmail(true)
        }

        if ( emailPattern.test(email) && pass.length > 0) {
            addLoginData();
        }
    };
    
    const addLoginData = async () => {
        try {
            const loginData = { username: email.toLowerCase(), password: pass };
            setIsLoading(true);
            if (email) {
                response = await axios.post(
                    `${process.env.REACT_APP_API_URL}/user/login`,
                    loginData
                );
                if (rememberMe) {
                    Cookies.set('rememberMe', true, { expires: 30 });
                } else {
                    Cookies.set('rememberMe', true);
                }

                userResponse = await axios.get(
                    `${process.env.REACT_APP_API_URL}/user/${response?.data?._id}?notification=${true}`
                );
                if (userResponse?.data?.result?.userMeta?.twoFactorAuth?.status === "enable") {
                    setUserId(response?.data?._id);
                    setLoginData(response?.data);
                    setIsLoading(false);
                    setStatus(userResponse?.data?.result?.userMeta?.twoFactorAuth?.status);
                    setAuthEmail(userResponse?.data?.result?.userMeta?.twoFactorAuth?.data || email);
                    setBack(true)

                    await axios.post(
                        `${process.env.REACT_APP_API_URL}/user/twoFactorEmailOTP/${response?.data?._id}`,
                        { email: userResponse?.data?.result?.userMeta?.twoFactorAuth?.data || email }
                    );

                } else {
                    setInputError(false);
                    sessionStorage.setItem("userId", response.data._id || "");
                    localStorage.setItem("userinfo", JSON.stringify(response?.data));
                    localStorage.setItem("isCompleted", response?.data?.isCompleted);
                    localStorage.setItem("isInvited", "false");
                    setBack(false)
                    setTimeout(() => {
                        if(response?.data?.isCompleted) {
                            window.location.href = "/"
                        } else {
                            window.location.href = "/sign-up"
                        }
                    }, 1000);
                }
            } else {
                setIsLoading(false);
            }
        } catch (error) {
            setIsLoading(false);
            if (error.response && error.response.status === 400) {
                setError(true);
            } else {
                console.log(error, "error");
                if (error?.response?.data?.message === "Your account disabled") {
                    setError(false);
                    setOpenBalancePopup(true)
                    setPaymentData(error?.response?.data)
                }
            }
        }
    };

    const handleInputChange = (index, value) => {
        if (value.length <= 1 && /^\d*$/.test(value)) {
            const newInputs = [...codeInputs];
            newInputs[index] = value;
            setCodeInputs(newInputs);

            if (value !== '') {
                if (index < codeInputs.length - 1) {
                    inputRefs.current[index + 1].focus();
                }
            } else {
                if (index > 0) {
                    inputRefs.current[index - 1].focus();
                }
            }
        }
    };

    const handleOtpPaste = (e) => {
        const paste = e.clipboardData.getData('text');
        if (/^\d{5}$/.test(paste)) { // Assuming OTP length is 5
            const newInputs = paste.split('');
            setCodeInputs(newInputs);
            newInputs.forEach((value, index) => {
                inputRefs.current[index].value = value;
                if (index < inputRefs.current.length - 1) {
                    inputRefs.current[index + 1].focus();
                }
            });
        }
        e.preventDefault();
    };

    const handleSend = async (e) => {
        e.preventDefault();
        try {
            setIsLoading(true);
            const otpDigit = codeInputs?.join('');
            if (codeInputs) {
                const payload = {
                    email: email,
                    otp: Number(otpDigit)
                };
                await axios.post(
                    `${process.env.REACT_APP_API_URL}/user/userOtpVerify/${userId}`,
                    payload
                );
                setInvalidOtpError(false);
                if (codeInputs?.some(input => input === '')) {
                    setInputError(true);
                    setInvalidOtpError(false);
                    setIsLoading(false);
                } else {
                    setInputError(false);
                    sessionStorage.setItem("userId", loginData?._id || "");
                    localStorage.setItem("userinfo", JSON.stringify(loginData));
                    localStorage.setItem("isCompleted", loginData?.isCompleted);
                    setTimeout(() => {
                        window.location.href = "/"
                    }, 1000);
                }
            } else {
                setIsLoading(false);
            }
        } catch (error) {
            if (error?.response?.data?.message) {
                setInvalidOtpError(true);
            } else {
                setInvalidOtpError(false);
            }
            setIsLoading(false);
        }
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            handleSend(e);
        }
    };

    return (
        <>
            <Helmet>
                <title>Sign In | Persone</title>
            </Helmet>
            <BgFormAnimate />
            <form className='form-design' onSubmit={handleSubmit}>
                <section className='login'>
                    {
                        openBalancePopup ? 
                            <div className='loginWindow'>
                                <Link to='https://jourmal-next-front.vercel.app/' target="_blank">
                                    <img className='person-logo' src={login} alt="Login" />
                                </Link>
                                <NegativeBalancePopup paymentData={paymentData} />
                            </div>
                        :
                            <>
                                <div className="loginWindow">
                                    <Link to='https://jourmal-next-front.vercel.app/' target="_blank">
                                        <img className='person-logo' src={login} alt="Login" />
                                    </Link>
                                    {
                                        status === 'enable' && status !== "" && isBack ?
                                            <>
                                                <p className='loginTitle'>Two Factor Authentication</p>
                                                <div className="popupContent">
                                                    <p className="popupDesc">Enter the code sent to your email address to log in to your account.</p>
                                                </div>

                                                <div className='input-verify-code' style={{ display: "flex", justifyContent: "center", marginTop: "8px" }}>
                                                    <div>
                                                        <div className='codeSection loginRow' style={{ marginTop: "10px" }} onPaste={handleOtpPaste}>
                                                            {codeInputs?.map((value, index) => (
                                                                <input
                                                                    key={index}
                                                                    type='number'
                                                                    name='otp'
                                                                    placeholder='0'
                                                                    className='code-input'
                                                                    value={value}
                                                                    maxLength={1}
                                                                    autoFocus={index === 0}
                                                                    onChange={e => handleInputChange(index, e.target.value)}
                                                                    ref={el => inputRefs.current[index] = el}
                                                                    onKeyPress={(e) => handleKeyPress(e)}
                                                                />
                                                            ))}
                                                        </div>
                                                        {inputError && <p className="validateError" style={{ textAlign: "center" }}>Please fill all code fields</p>}
                                                        {invalidOtpError && <p className="validateError" style={{ textAlign: "center" }}>Incorrect code, please try again</p>}
                                                    </div>
                                                </div>
                                                <div className='resend-text'>
                                                    <p style={{ display: "flex", justifyContent: "center", margin: "5px" }}>Didn’t get a code? <Link style={{ margin: "0 5px" }} onClick={() => {
                                                        axios.post(
                                                            `${process.env.REACT_APP_API_URL}/user/twoFactorEmailOTP/${userId}`,
                                                            { email: authEmail }
                                                        );
                                                        setCodeInputs(["", "", "", "", ""])
                                                    }}> Click to resend.</Link></p>
                                                </div>

                                                <div className="popupButtons" >

                                                    <button className='backButton button' style={{ width: "50%" }} onClick={() => { setBack(false); setInvalidOtpError(false); setCodeInputs(["", "", "", "", ""]) }}>
                                                        <svg width="16" height="13" viewBox="0 0 16 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M14.3335 6.5L1.00016 6.5M1.00016 6.5L6.00016 11.5M1.00016 6.5L6.00016 1.5" stroke="#344054" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                        </svg>
                                                        Back
                                                    </button>
                                                    <button className='settingsBlue billingSaveBtn button' style={{ width: "50%", marginRight: "0px" }} onClick={handleSend} type='submit'>
                                                        {isLoading ?
                                                            <div className="registerLoader">
                                                                <div className="ring-loader"></div>
                                                            </div>
                                                            : <>
                                                                Continue
                                                                <svg width="16" height="13" viewBox="0 0 16 13" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ rotate: "180deg", marginLeft: "5px", marginTop: '1px' }}>
                                                                    <path d="M14.3335 6.5L1.00016 6.5M1.00016 6.5L6.00016 11.5M1.00016 6.5L6.00016 1.5" stroke="#ffffff" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                                </svg>
                                                            </>
                                                        }
                                                    </button>
                                                </div>
                                            </> :
                                            <>
                                                <p className='loginTitle login-page-title'>Sign in to your account</p>
                                                <p className='loginSubtitle'>Please enter your login details</p>
                                                <div className='loginRow login-input-box'>
                                                    <p>Email</p>
                                                    <input type="text" name="email" placeholder='Enter your email' value={email} autoFocus={true} onChange={e => {
                                                        setEmail(e.target.value)
                                                        if (e.target.value.length > 0) {
                                                            setValidateEmail(false);
                                                        }
                                                    }}
                                                        className={(validateEmail === true) ? 'inputError' : ''} />
                                                    {
                                                        (validateEmail === true) ? <p className='validateError'>Please enter a valid email address</p> : ''
                                                    }

                                                </div>
                                                <div className='loginRow login-input-box'>
                                                    <p>Password</p>
                                                    <input type="password" name="password" placeholder='Enter your password' value={pass} onChange={e => {
                                                        setPass(e.target.value)

                                                        if (e.target.value.length > 0) {
                                                            setValidatePass(false)
                                                        }
                                                    }}
                                                        className={(validatePass === true) ? 'inputError' : ''} />
                                                    {
                                                        (validatePass === true) ? <p className='validateError'>Please enter your password</p> : ''
                                                    }
                                                </div>
                                                <div className='loginRow'>
                                                    {
                                                        (error === true) ? <p className='validateError'>Email and password do not match, please try again.</p> : ''
                                                    }
                                                </div>

                                                <div className="loginInfo">
                                                    <div>
                                                        <input type="checkbox" id="loginCheckbox" checked={rememberMe} onChange={() => setRememberMe(!rememberMe)}/>
                                                        <label htmlFor="loginCheckbox">Remember for 30 days</label>
                                                    </div>
                                                    <Link to={'/forgot-password'}>Forgot password</Link>
                                                </div>

                                                <button className={`loginButton button ${isLoading ? 'btn_loading' : ''}`} type='submit'>
                                                    {isLoading ?
                                                        <div className="registerLoader">
                                                            <div className="ring-loader"></div>
                                                        </div>
                                                        : "Sign in"}
                                                </button>
                                            </>
                                    }

                                    <p className='loginBottom'>Don’t have an account? <Link to={'/sign-up'}>Sign up</Link></p>
                                </div>
                                <div className='pvivacy_mobile'>
                                    <p>© Persone {new Date().getFullYear()}. All Rights Reserved. <span className='login-footer-link'>Terms of Service</span> & <span className='login-footer-link'>Privacy Policy</span>.</p>
                                </div>
                            </>
                    }
                </section>
            </form>
        </>
    );
}

export default Login;
